import { CityTag } from '../../types/domain';
/** city item 标签文案兜底 */
const DEFAULT_CITY_TAG_TEXT = '心动城市';
/**
 * 将城市列表按首字母分组并排序
 */
export function groupCitiesByLetter(cities) {
    const map = {};
    for (const city of cities) {
        const firstLetter = (city.pinyin?.trim()[0] ?? city.name[0])?.toUpperCase();
        if (!firstLetter)
            continue;
        if (!map[firstLetter])
            map[firstLetter] = [];
        map[firstLetter].push(city);
    }
    return Object.keys(map).sort((a, b) => a.charCodeAt(0) - b.charCodeAt(0)).map(label => ({
        label,
        data: map[label]
    }));
}
/**
 * 获取分组后所有的字母列表
 */
export function getLetters(groups) {
    return groups.map(g => g.label);
}
/**
 * 按关键词搜索城市（名称或拼音匹配）
 */
export function searchCities(cities, keyword) {
    if (!keyword)
        return [];
    const kw = keyword.toLowerCase();
    return cities.filter(city => city.name.includes(keyword) || (city.pinyin ?? '').toLowerCase().includes(kw));
}
/**
 * 将接口返回的 CardGroupInfoVO[] 转换为城市筛选组件所需的 CityInfo[]
 *
 * 接口字段映射：
 *   groupKey  → id
 *   groupName → name
 *   extra.pinyin → pinyin（用于字母分组和搜索）
 */
export function convertCardGroupsToCities(groups) {
    if (!Array.isArray(groups))
        return [];
    return groups.map(group => ({
        id: group.groupKey,
        name: group.groupName,
        iconUrl: group.iconUrl,
        pinyin: group.extra?.pinyin,
        cityTag: group.extra?.cityTag
    }));
}
/** city item 标签文案：玩水城市(cityTag===1)用运营配置，其余/未配置兜底「心动城市」 */
export function resolveCityTagText(cityTag, waterCityTagText) {
    if (cityTag === CityTag.Water)
        return waterCityTagText || DEFAULT_CITY_TAG_TEXT;
    return DEFAULT_CITY_TAG_TEXT;
}
